import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DropdownComp from "../dropdown";
import Input from "../input";
import ButtonContained from "../button";
import { AddProductSchema } from "../../validation/ValidationSchema";
import { api } from "../../api";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";
import {
  getMasterProductsList,
  getEzPinProductsList,
  getGenbaProductsList,
  getGenbaProductPriceList,
  getAppIdForGenbaProductName,
} from "../../helpers/listsApi";

const AddProduct = () => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);
  const region = useSelector((state) => state.auth.region);
  // eslint-disable-next-line
  const { userType: role } = useSelector((state) => state.auth.user);

  const [apiAccess, setApiAccess] = useState(false);
  const [productDataList, setProductDataList] = useState([
    { value: "", label: "please select" },
  ]);
  const [masterDataList, setMasterDataList] = useState([
    { value: "", label: "please select" },
  ]);
  // eslint-disable-next-line no-unused-vars
  const [genbaProductId, setGenbaAppId] = useState([{}]);
  const [data, setData] = useState([]);
  const [genbaData, setGenbaData] = useState([]);

  const checkApiAccess = (e) => {
    setApiAccess(e.target.checked);
  };

  const productList = productDataList.length
    ? productDataList
    : [{ value: "", label: "please select" }];

  const options = productList;

  //loading
  const [isLoading, setIsLoading] = useState(false);
  const [currentMerchant, setCurrentMerchant] = useState({});
  const [currentProduct, setCurrentProduct] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [currentGenba, setCurrentGenba] = useState({});

  useEffect(() => {
    api.brands.getBrandList({}, token).then((res) => {
      var productList = [];
      if (res.code === 200) {
        for (let i of res.data.result) {
          productList.push({ value: i.brandId, label: i.brandName });
        }
        setProductDataList(productList);
      }
    });
  }, [token]);
  useEffect(
    (_) => {
      getMasterProductsList(currentMerchant.value, token)
        .then(
          (res) => Object.keys(currentMerchant).length && setMasterDataList(res)
        )
        .catch((err) => console.log(err, " err"));
    },
    [currentMerchant, token]
  );

  useEffect(
    (_) => {
      getAppIdForGenbaProductName(currentProduct.value, token)
        .then((res) => Object.keys(currentProduct).length && setGenbaAppId(res))
        .catch((err) => console.log(err, " err"));
    },
    [currentProduct, token]
  );

  useEffect(() => {
    getEzPinProductsList(
      {
        limit: 150,
        offset: 1,
      },
      token
    ).then((res) => {
      setData(res);
    });
  }, [token]);

  useEffect(() => {
    getGenbaProductsList({}, token).then((res) => {
      setGenbaData(res);
    });
  }, [token]);

  const getGenbaPriceValue = async (selectedValue) => {
    let result = await getGenbaProductPriceList(selectedValue?.sku);

    return filterINRCurrencyData(result);
    // return result;
  };

  const getGenbaProductName = async (selectedValue) => {
    let result = await getAppIdForGenbaProductName(selectedValue?.name);

    return result;
  };

  const filterINRCurrencyData = (value) => {
    return value && value.filter((data) => data.currencycode === "INR");
  };

  return (
    <Formik
      validationSchema={AddProductSchema}
      initialValues={{
        productBrand: "",
        ezPinProducts: "",
        genbaProducts: "",
        margin: "",
        trashHold: "",
        genbaCutOffPrice: "",
        genbaMaxPrice: "",
        genbaSteamAppId: "",
        master: "",
        productDenomination: "",
        productDenominationAmt: "",
        productSku: "",
        isDevco: false,
        devcoProductId: "",
        isEpay: false,
        epayProductId: "",
        epayBillerId: "",
      }}
      onSubmit={(values, { resetForm }) => {
        const masterArr = values.master.map((mr) => mr.value);
        setIsLoading(true);
        const brands = [
          {
            productName: values.productDenomination,
            productPrice: values.productDenominationAmt,
            productApiAccess: apiAccess,
            productThreshold: values.trashHold,
            masterProductIds: masterArr,
            productsku: values.productSku,
            // genbaMaxPrice: values.genbaMaxPrice,
            genbaCutOffPrice: values.genbaCutOffPrice,
            genbaSteamAppId: values.genbaSteamAppId,
            isDevco: values.isDevco,
            devcoProductId: values.devcoProductId,
            isEpay: values.isEpay,
            epayProductId: values.epayProductId,
            epayBillerId: values.epayBillerId,
          },
        ];
        const formBody = {
          productBrandId: values.productBrand.value,
          productMargin: values.margin,
          productArray: brands,
        };
        api.products
          .create(formBody, token)
          .then((res) => {
            if (res.code === 200) {
              resetForm();
              setIsLoading(false);
              toast.success(res.message);
              navigate("/products-denomination");
            } else {
              resetForm();
              setIsLoading(false);
              toast.error(res.message);
            }
          })
          .catch((err) => {
            resetForm();
            setIsLoading(false);
            toast.error("!Oops, Something went wrong", "error");
          });
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
        isSubmitting,
        setFieldValue,
      }) => {
        const ez =
          values &&
          values.productBrand &&
          values.productBrand.label === "EZ PIN";
        const ge =
          values &&
          values.productBrand &&
          values.productBrand.label === "Genba";
        // eslint-disable-next-line no-unused-vars
        const test = values.ezPinProducts;
        return (
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="box-row">
                  <div className="table-head">
                    <h1 className="sec-header">ADD PRODUCT</h1>
                  </div>
                  <div className="card card-table">
                    {/* <div className="card-header card-header-title">
                      {" "}
                      Product Details
                    </div> */}
                    <div className="card-body gatepass-saveoutput">
                      <div className="reports">
                        <Form onSubmit={handleSubmit}>
                          <div className="form-row">
                            <div
                              className={`form-group col-md-${
                                ez || ge ? `3` : `4`
                              }`}
                            >
                              <DropdownComp
                                id="productBrand"
                                name="productBrand"
                                onChange={(selectedValue) => {
                                  setFieldValue("productBrand", selectedValue);
                                  setCurrentMerchant(selectedValue);
                                }}
                                value={values.productBrand}
                                options={options}
                                label="Brand"
                                placeholder="Brand"
                                error={
                                  touched.productBrand && errors.productBrand
                                }
                                errorText={errors.productBrand}
                                disabled={isSubmitting}
                              />
                            </div>
                            {ez && (
                              <div className="form-group col-md-3">
                                <DropdownComp
                                  id="ezPinProducts"
                                  name="ezPinProducts"
                                  onChange={(selectedValue) => {
                                    setFieldValue(
                                      "ezPinProducts",
                                      selectedValue
                                    );
                                    setFieldValue(
                                      "productDenomination",
                                      selectedValue.value
                                    );
                                    setFieldValue(
                                      "productDenominationAmt",
                                      selectedValue.min_price ===
                                        selectedValue.max_price
                                        ? selectedValue.max_price
                                        : ""
                                    );
                                    setFieldValue(
                                      "productSku",
                                      `EZ_${selectedValue.sku}_${selectedValue.currency}_${selectedValue.max_price}`
                                    );
                                  }}
                                  value={values.ezPinProducts}
                                  options={data}
                                  label="EZ PIN Products"
                                  placeholder="EZ PIN Products"
                                  error={
                                    touched.ezPinProducts &&
                                    errors.ezPinProducts
                                  }
                                  errorText={errors.ezPinProducts}
                                  disabled={isSubmitting}
                                />
                              </div>
                            )}
                            {ge && (
                              <div className="form-group col-md-3">
                                <DropdownComp
                                  id="genbaProducts"
                                  name="genbaProducts"
                                  onChange={async (selectedValue) => {
                                    setCurrentGenba(
                                      getGenbaPriceValue(selectedValue)
                                    );
                                    let result = await getGenbaPriceValue(
                                      selectedValue
                                    );
                                    setFieldValue(
                                      "genbaProducts",
                                      selectedValue
                                    );
                                    setFieldValue(
                                      "productDenomination",
                                      selectedValue.value
                                    );
                                    setFieldValue(
                                      "productDenominationAmt",
                                      result[0]?.srp
                                    );
                                    setFieldValue(
                                      "productSku",
                                      `GENBA_${selectedValue.sku}`
                                    );
                                    // setCurrentProduct(selectedValue)
                                    setCurrentProduct(
                                      getGenbaProductName(selectedValue)
                                    );
                                    let resultt = await getGenbaProductName(
                                      selectedValue
                                    );
                                    setFieldValue(
                                      "genbaSteamAppId",
                                      resultt[0]?.value
                                    );
                                  }}
                                  value={values.genbaProducts}
                                  options={genbaData}
                                  label="GENBA Products"
                                  placeholder="GENBA Products"
                                  error={
                                    touched.genbaProducts &&
                                    errors.genbaProducts
                                  }
                                  errorText={errors.genbaProducts}
                                  disabled={isSubmitting}
                                />
                              </div>
                            )}
                            <div
                              className={`form-group col-md-${
                                ez || ge ? `3` : `4`
                              }`}
                            >
                              <Input
                                id="margin"
                                name="margin"
                                placeholder="Nodwin Margin"
                                type="number"
                                label="Nodwin Margin"
                                value={values.margin}
                                onChange={handleChange}
                                error={touched.margin && errors.margin}
                                errorText={errors.margin}
                                percentage={true}
                                disabled={isSubmitting}
                              />
                            </div>
                            <div
                              className={`form-group col-md-${
                                ez || ge ? `3` : `4`
                              }`}
                            >
                              <Input
                                id="trashHold"
                                name="trashHold"
                                placeholder="Minimum Quantity"
                                type="number"
                                label="Minimum Quantity"
                                value={values.trashHold}
                                onChange={handleChange}
                                error={touched.trashHold && errors.trashHold}
                                errorText={errors.trashHold}
                                disabled={isSubmitting}
                              />
                            </div>
                          </div>

                          {/* // */}
                          <div className="form-row">
                            <div
                              className={`form-group col-md-${
                                ez || ge ? `3` : `4`
                              }`}
                            >
                              <Input
                                id="productDenomination"
                                name="productDenomination"
                                placeholder="Product Denomination"
                                type="text"
                                label="Product Denomination"
                                value={values.productDenomination}
                                onChange={handleChange}
                                error={
                                  touched.productDenomination &&
                                  errors.productDenomination
                                }
                                errorText={errors.productDenomination}
                                disabled={isSubmitting}
                              />
                            </div>

                            <div
                              className={`form-group col-md-${
                                ez || ge ? `3` : `4`
                              }`}
                            >
                              <Input
                                id="productDenominationAmt"
                                name="productDenominationAmt"
                                placeholder="Product Denomination Amount"
                                type="number"
                                label="Product Denomination Amount"
                                value={values.productDenominationAmt}
                                onChange={handleChange}
                                error={
                                  touched.productDenominationAmt &&
                                  errors.productDenominationAmt
                                }
                                errorText={
                                  errors.productDenominationAmt &&
                                  errors.productDenominationAmt
                                }
                                disabled={isSubmitting}
                              />
                            </div>
                            <div
                              hidden={!ge}
                              className={`form-group col-md-${ge ? `3` : `4`}`}
                            >
                              <Input
                                id="genbaCutOffPrice"
                                name="genbaCutOffPrice"
                                placeholder="Product Cut Off Amount"
                                type="number"
                                label="Product Cut Off Amount"
                                value={values.genbaCutOffPrice}
                                onChange={handleChange}
                                error={
                                  touched.genbaCutOffPrice &&
                                  errors.genbaCutOffPrice
                                }
                                errorText={errors.genbaCutOffPrice}
                                disabled={isSubmitting}
                              />
                            </div>
                            <div
                              hidden={!ge}
                              className={`form-group col-md-${ge ? `3` : `4`}`}
                            >
                              <Input
                                readOnly
                                id="genbaSteamAppId"
                                name="genbaSteamAppId"
                                placeholder="Steam App Id"
                                type="number"
                                label="Steam App Id"
                                value={values.genbaSteamAppId}
                                onChange={handleChange}
                                error={
                                  touched.genbaSteamAppId &&
                                  errors.genbaSteamAppId
                                }
                                errorText={errors.genbaSteamAppId}
                                disabled={isSubmitting}
                              />
                            </div>
                            {/* <FieldArray
                            name="ProductArr"
                            render={(helper) => {
                              return (
                                <div>
                                  {values.ProductArr &&
                                    values.ProductArr.length > 0 &&
                                    values.ProductArr.map(
                                      (ProductArr, index) => {
                                        return (
                                          <AddDenominationRow
                                            key={index}
                                            index={index}
                                            values={values}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                            touched={touched}
                                            errors={errors}
                                            isSubmitting={isSubmitting}
                                            handleRemoveProduct={() =>
                                              helper.remove(index)
                                            }
                                          />
                                        );
                                      }
                                    )}
                                  <button
                                    disabled={isSubmitting}
                                    type="button"
                                    onClick={() => {
                                      helper.push({
                                        productDenomination: "",
                                        productDenominationAmt: "",
                                      });
                                    }}
                                    className="btn mt-3 submit-btn"
                                    htmlFor="gridCheck"
                                  >
                                    Add Row
                                  </button>
                                </div>
                              );
                            }}
                          ></FieldArray> */}
                            <div
                              className={`form-group col-md-${
                                ez || ge ? `3` : `4`
                              }`}
                            >
                              <DropdownComp
                                id="master"
                                name="master"
                                placeholder="Master product"
                                label="Master Product"
                                value={values.master}
                                isMulti
                                onChange={(selectedValue) => {
                                  setFieldValue("master", selectedValue);
                                }}
                                options={masterDataList}
                                error={touched.master && errors.master}
                                errorText={errors.master}
                                disabled={isSubmitting}
                              />
                            </div>
                            <div
                              hidden={!ez}
                              className={`form-group col-md-${ez ? `3` : `4`}`}
                            >
                              <Input
                                readOnly
                                id="productsku"
                                name="productSku"
                                placeholder="Product SKU"
                                type="text"
                                label="Product SKU"
                                value={ez && values.productSku}
                                onChange={handleChange}
                                error={touched.productSku && errors.productSku}
                                errorText={errors.productSku}
                                disabled={isSubmitting}
                              />
                            </div>
                            <div
                              hidden={!ge}
                              className={`form-group col-md-${ez ? `3` : `4`}`}
                            >
                              <Input
                                readOnly
                                id="productsku"
                                name="productSku"
                                placeholder="Product SKU"
                                type="text"
                                label="Product SKU"
                                value={ge && values.productSku}
                                onChange={handleChange}
                                error={touched.productSku && errors.productSku}
                                errorText={errors.productSku}
                                disabled={isSubmitting}
                              />
                            </div>
                          </div>

                          <div hidden={ez || ge} className="form-row">
                            <div
                              className={`form-group col-md-${
                                ez || ge ? `3` : `4`
                              }`}
                            >
                              <Input
                                id="productsku"
                                name="productSku"
                                placeholder="Product SKU"
                                type="text"
                                label="Product SKU"
                                value={values.productSku}
                                onChange={handleChange}
                                error={touched.productSku && errors.productSku}
                                errorText={errors.productSku}
                                disabled={isSubmitting}
                              />
                            </div>
                          </div>

                         <div className="form-row">
    <div className="form-group col-md-6">
      <label className="form-label">Product Source</label>

      {/* DEVCO */}
      {region.currency === "USD" && (
      <div className="form-check mb-2">
        <input
          type="checkbox"
          className="form-check-input"
          id="isDevco"
          name="isDevco"
          checked={values.isDevco}
          onChange={(e) => {
            const checked = e.target.checked;

            setFieldValue("isDevco", checked);

            // only one source allowed
            if (checked) {
              setFieldValue("isEpay", false);
              setFieldValue("epayProductId", "");
            }

            if (!checked) {
              setFieldValue("devcoProductId", "");
            }
          }}
          disabled={isSubmitting || values.isEpay}
        />

        <label className="form-check-label" htmlFor="isDevco">
          Devco
        </label>

        <small className="form-text text-muted">
          Check this if the product will be purchased from Devco
        </small>
      </div>
      )}

      {/* EPAY */}
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="isEpay"
          name="isEpay"
          checked={values.isEpay}
          onChange={(e) => {
            const checked = e.target.checked;

            setFieldValue("isEpay", checked);

            // only one source allowed
            if (checked) {
              setFieldValue("isDevco", false);
              setFieldValue("devcoProductId", "");
            }

            if (!checked) {
              setFieldValue("epayProductId", "");
              setFieldValue("epayBillerId", "");
            }
          }}
          disabled={isSubmitting || values.isDevco}
        />

        <label className="form-check-label" htmlFor="isEpay">
          Epay
        </label>

        <small className="form-text text-muted">
          Check this if the product will be purchased from Epay
        </small>
      </div>
    </div>

    {/* DEVCO PRODUCT ID */}
    {region.currency === "USD" && values.isDevco && (
      <div className="form-group col-md-6">
        <Input
          id="devcoProductId"
          name="devcoProductId"
          placeholder="Devco Product ID"
          type="text"
          label="Devco Product ID"
          value={values.devcoProductId}
          onChange={handleChange}
          error={
            touched.devcoProductId && errors.devcoProductId
          }
          errorText={errors.devcoProductId}
          disabled={isSubmitting}
        />

        <small className="form-text text-muted">
          This product ID is used to purchase the product from Devco.
        </small>
      </div>
    )}

    {/* EPAY PRODUCT ID */}
    {values.isEpay && (
      <div className="form-group col-md-6">
        <Input
          id="epayProductId"
          name="epayProductId"
          placeholder="Epay Product ID"
          type="text"
          label="Epay Product ID"
          value={values.epayProductId}
          onChange={handleChange}
          error={
            touched.epayProductId && errors.epayProductId
          }
          errorText={errors.epayProductId}
          disabled={isSubmitting}
        />

        <small className="form-text text-muted">
          This product ID is used to purchase the product from Epay.
        </small>

        <Input
          id="epayBillerId"
          name="epayBillerId"
          placeholder="Epay Biller ID"
          type="text"
          label="Epay Biller ID"
          value={values.epayBillerId}
          onChange={handleChange}
          error={
            touched.epayBillerId && errors.epayBillerId
          }
          errorText={errors.epayBillerId}
          disabled={isSubmitting}
        />

        <small className="form-text text-muted">
          This biller ID is used to purchase the product from Epay.
        </small>
      </div>
    )}
  </div>
                          <div className="form-row">
                            <div className="form-group col-md-4">
                              <label htmlFor="customCheck">Alert </label>
                              <br />
                              <div className="custom-control custom-checkbox mb-3 mt-3">
                                <input
                                  onChange={checkApiAccess}
                                  value={apiAccess}
                                  style={{ zIndex: "100" }}
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="customCheck"
                                  name="example1"
                                  disabled={isSubmitting}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customCheck"
                                >
                                  {" "}
                                  API Access
                                </label>
                              </div>
                            </div>
                          </div>

                          <ButtonContained
                            buttonName="Save"
                            disabled={isSubmitting}
                            loading={isLoading}
                          >
                            <Loader />
                          </ButtonContained>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </Formik>
  );
};

export default AddProduct;
